import dayjs from 'dayjs'
import type { FC } from 'react'
import { Fragment } from 'react'

import { Tag } from '@/components/Tag'
import useNextWeekMenu from '@/hooks/useNextWeekMenu'
import type { CMSNWMpage } from '@/types/sanity'

import './NextWeekMenuFlyOut.scss'

interface NectWeekMenuFlyoutProps {
  nextweekmenu?: CMSNWMpage
  displayStickyCTA?: boolean
}

export const NextWeekMenuFlyOut: FC<NectWeekMenuFlyoutProps> = ({
  nextweekmenu,
  displayStickyCTA = true,
}) => {
  const { currentWeekMenuTabItem, isLoading, isMenuLoading } = useNextWeekMenu()

  if (isLoading || isMenuLoading) {
    return <div style={{ margin: '0 auto' }}> Loading...</div>
  }

  const scrollToBuyingPanel = () => {
    const header = document.querySelector('.header') as HTMLElement
    const buyingPanelHeader = document.querySelector(
      '.program-panel-header',
    ) as HTMLElement

    const flyoutLinks = nextweekmenu?.flyout?.links
    const selectedLink = flyoutLinks?.find((link) =>
      window.location.pathname.match((link.link as any).external),
    )

    if (buyingPanelHeader && header && selectedLink) {
      const multiplyingFactor =
        window.scrollY > buyingPanelHeader.offsetTop ? 2 : 1

      window.scroll({
        top:
          buyingPanelHeader.offsetTop - multiplyingFactor * header.offsetHeight,
        behavior: 'smooth',
      })
    } else {
      window.location.href = '/nutrition/signature-nutrition-program'
    }

    const button = document.querySelector('.modal__close-button')
    button?.dispatchEvent(new Event('click'))
  }

  return (
    <div className="fly-out-week-wrapper">
      <div className="fly-out-week-inner-wrapper">
        <h4 className="type-h4">
          {`Week of ${dayjs(currentWeekMenuTabItem.date).format('MMMM D')}`}
        </h4>
        {currentWeekMenuTabItem.menu.map((dayData) => {
          const { date, meals } = dayData
          const _dateDay = dayjs(date).format('dddd')
          return (
            <Fragment key={_dateDay}>
              <div className="fly-out-week-inner-wrapper__weekday">
                <h5 className="type-h5">{_dateDay}</h5>
                <div className="fly-out-week-inner-wrapper__weekday__day">
                  {meals.map((meal) => {
                    const { dayImageUrl: image, description, title } = meal
                    return (
                      <div
                        key={meal.id}
                        className={
                          'fly-out-week-inner-wrapper__weekday__day__card'
                        }
                      >
                        <div className="fly-out-week-inner-wrapper__weekday__day__card__image">
                          <img src={image} alt={title} />
                        </div>
                        <div className="fly-out-week-inner-wrapper__weekday__day__card__content">
                          {meal.new && (
                            <div className="fly-out-week-inner-wrapper__weekday__day__card__content__new">
                              <Tag text="NEW MEAL" theme="kiwi" />
                            </div>
                          )}
                          <span className="fly-out-week-inner-wrapper__weekday__day__card__content__title type-label">
                            {title}
                          </span>
                          <p className="fly-out-week-inner-wrapper__weekday__day__card__content__description">
                            {description}
                          </p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </Fragment>
          )
        })}
      </div>
      {displayStickyCTA && (
        <div className="fly-out-week-inner-wrapper__footer">
          <div
            onClick={scrollToBuyingPanel}
            className="fly-out-week-inner-wrapper__footer__button button button-primary"
          >
            Sign Up Now
          </div>
        </div>
      )}
    </div>
  )
}
